import { interpolateRdYlGn } from 'd3-scale-chromatic'

export const createHeatmapGradientString = (checkpoints: number) => {
  let str = ''
  let max = checkpoints > 100 ? 100 : checkpoints
  for (let i = 0; i < max; i++) {
    str += `${interpolateRdYlGn(i / max)},`
  }
  return str + 'rgb(0,0,0)'
}
